export default __webpack_public_path__ + "static/media/user-management-active.8dbebdf0.svg";